import PropTypes from "prop-types";

import { FlexContainers } from "../../components";
import { TableContentWrapper } from "./styled";

const TableComponent = ({ component, disableScroll, modalTable }) => {
  return (
    component && (
      <TableContentWrapper
        disableScroll={disableScroll}
        modalTable={modalTable}
        Container={FlexContainers.FlexColumnCenter}>
        {component}
      </TableContentWrapper>
    )
  );
};

TableComponent.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  disableScroll: PropTypes.bool,
  modalTable: PropTypes.bool
};

export default TableComponent;
